function renderSnippet(rating, num_ratings, text, linebreak) {
    var ratingHtml = '';
    for (var s = 1; s <= Math.ceil(rating); s++) ratingHtml += '<i class="ruk-icon-full-star-01" style="font-family: \'product-widget-iconfont\'"></i>';
    for (var s = s; s <= 5; s++) ratingHtml += '<i class="ruk-icon-empty-star-01" style="font-family: \'product-widget-iconfont\'"></i>';
    if (linebreak == true) {
        ratingHtml += '<br />';
    }
    if (num_ratings > 0) { 
        ratingHtml += '<span class="ruk-rating-snippet-count">(' + num_ratings + text + ')</span>';
    } else {
        ratingHtml += '<span class="ruk-rating-snippet-count">Leave a review!</span>';
    }
    return ratingHtml;
}
ratingSnippet = function(ratingClassName, opts) {
    if (opts == undefined) {
        opts = {}
    }
    if (opts.linebreak == undefined) {
        opts.linebreak = false;
    }
    if (opts.color == undefined) {
        opts.color = '#67c116'
    }
    if (opts.useCustomLookup == undefined) {
        opts.useCustomLookup = false;
    }
    if (opts.customLookupSkuFallback == undefined) {
        opts.customLookupSkuFallback = false;
    }
    if (opts.showNumberDatesFormat == undefined) {
        opts.showNumberDatesFormat = 'dd.MM.yyyy';
    }
    if (opts.showNumberDates == undefined) {
        opts.showNumberDates = false;
    }
    if (opts.translateAverage == undefined) {
        opts.translateAverage = 'Average';
    }
    if (opts.translateReviews == undefined) {
        opts.translateReviews = 'Reviews';
    }
    if (opts.translateNoReviews == undefined) {
        opts.translateNoReviews = 'Be the first to review this product.';
    }
    if (opts.translateMoreRatings == undefined) {
        opts.translateMoreRatings = 'More Ratings';
    }
    if (opts.translateNoComments == undefined) {
        opts.translateNoComments = 'This review has no comments';
    }
    if (opts.translateReplyFrom == undefined) {
        opts.translateReplyFrom = 'Reply From';
    }
    if (opts.translatePosted == undefined) {
        opts.translatePosted = 'Posted';
    }
    if (opts.translateWriteReview == undefined) {
        opts.translateWriteReview = 'Write a Review';
    }
    if (opts.translateShow == undefined) {
        opts.translateShow = 'Show';
    }
    if (opts.translateDetails == undefined) {
        opts.translateDetails = 'More';
    }
    if (opts.translateRateThisProduct == undefined) {
        opts.translateRateThisProduct = 'Rate This Product';
    }
    if (opts.translateSelectProduct == undefined) {
        opts.translateSelectProduct = 'Select Product:';
    }
    if (opts.translateWriteReviewPlaceholder == undefined) {
        opts.translateWriteReviewPlaceholder = 'Write your review here';
    }
    if (opts.translateSubmitReview == undefined) {
        opts.translateSubmitReview = 'Submit Review';
    }
    if (opts.translateYourNamePlaceholder == undefined) {
        opts.translateYourNamePlaceholder = 'Your Name';
    }
    if (opts.translateEmailAddressPlaceholder == undefined) {
        opts.translateEmailAddressPlaceholder = 'Email Address';
    }
    if (opts.translateThankyouForYourReview == undefined) {
        opts.translateThankyouForYourReview = '<strong>Thank you</strong> for your review!';
    }
    if (opts.translateYourReviewHasBeenSubmitted == undefined) {
        opts.translateYourReviewHasBeenSubmitted = 'Your review has been submitted.';
    }
    if (opts.translateReviewsCount == undefined) {
        opts.translateReviewsCount = 'Reviews';
    }
    if (opts.translateVerifiedBuyer == undefined) {
        opts.translateVerifiedBuyer = 'Verified Buyer';
    }
    if (opts.translateUnverifiedBuyer == undefined) {
        opts.translateUnverifiedBuyer = 'Unverified Buyer';
    }
    if (opts.translateVerifiedBuyerYes == undefined) {
        opts.translateVerifiedBuyerYes = 'Yes';
    }
    if (opts.translateVerifiedBuyerNo == undefined) {
        opts.translateVerifiedBuyerNo = 'No';
    }
    if (opts.translateAnonymousReviewerName == undefined) {
        opts.translateAnonymousReviewerName = 'Anonymous';
    }
    var store;
    var sku = [];
    var rating_snippets = document.querySelectorAll('.' + ratingClassName);
    if (rating_snippets.length > 0) {
        for (var i in rating_snippets) {
            var snippet = rating_snippets.item(i);
            var _sku = snippet.getAttribute('data-sku').split(';');
            sku = sku.concat(_sku);
        }
    }
    var xmlhttp;
    if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
    } else {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
            var data = JSON.parse(xmlhttp.responseText);
            console.log(data);
            var rating_snippets = document.querySelectorAll('.' + ratingClassName);
            if (rating_snippets.length > 0) {
                for (var x = 0; x < rating_snippets.length; x++) {
                    var snippet = rating_snippets.item(x);
                    var _sku = snippet.getAttribute('data-sku').split(';');
                    var rating = 0,
                        rating_count = 0,
                        num_ratings = 0;
                    rating = data.rating;
                    rating_count = data.count;
                    num_ratings = data.count;
                    if (rating_count > 0) {
                        var ratingText = (opts.text != undefined) ? ' ' + opts.text : '';
                        if (ratingText == ' Reviews' && num_ratings == 1) {
                            ratingText = ' Review';
                        }
                        snippet.innerHTML = renderSnippet(rating, num_ratings, ratingText, opts.linebreak);
                        snippet.setAttribute('data-done', true);
                    } else {
                        snippet.innerHTML = renderSnippet(0,0,null,true);
                        snippet.setAttribute('data-done', true);
                    } 
                    
                    if (opts.callback) {
                        opts.callback({
                            data: data,
                            rating: rating,
                            count: rating_count
                        });
                    }
                }
            }
        }
    }
    var _sku = encodeURIComponent(sku.join(';'));
    if (_sku == '') {
        return;
    }
    var queryString = 'sku=' + _sku + '&store=' + opts.store + '&useCustomLookup=' + opts.useCustomLookup + '&customLookupSkuFallback=' + opts.customLookupSkuFallback;
    if (queryString.length > 2000) {
        xmlhttp.open('POST', 'https://api-cache.reviews.co.uk/product/rating', true);
        xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xmlhttp.send(queryString);
    } else {
        xmlhttp.open('GET', 'https://api-cache.reviews.co.uk/product/rating?' + queryString, true);
        xmlhttp.send();
    }
    var rating_snippets = document.querySelectorAll('.' + ratingClassName);
    if (rating_snippets.length > 0) {
        for (var i in rating_snippets) {
            var snippet = rating_snippets.item(i);
            if (opts.color != undefined) {
                snippet.style.color = opts.color;
            }
            if ((typeof productWidget != 'undefined') && (snippet.onclick == null)) {
                snippet.onclick = function(event) {
                    var sku = this.getAttribute('data-sku');
                    if (!this.getAttribute('data-done')) {
                        return;
                    }
                    var root = document.getElementsByTagName('html')[0];
                    var isIphone = /(iPhone)/i.test(navigator.userAgent);
                    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/i);
                    document.getElementById('reviews_widget').innerHTML = '';
                    var options = {
                        store: opts.store,
                        sku: sku,
                        css: opts.css,
                        primaryClr: opts.color,
                        neutralClr: "#EBEBEB",
                        buttonClr: "#EEE",
                        textClr: "#333",
                        tabClr: "#eee",
                        questions: true,
                        showTabs: false,
                        ratingStars: false,
                        showAvatars: true,
                        snippetPopup: true,
                        hidePoweredBy: opts.hidePoweredBy ? opts.hidePoweredBy : false,
                        hideLogo: opts.hideLogo ? opts.hideLogo : false,
                        showNumberDates: opts.showNumberDates,
                        showNumberDatesFormat: opts.showNumberDatesFormat,
                        translateAverage: opts.translateAverage,
                        translateReviews: opts.translateReviews,
                        translateNoReviews: opts.translateNoReviews,
                        translateMoreRatings: opts.translateMoreRatings,
                        translateNoComments: opts.translateNoComments,
                        translateReplyFrom: opts.translateReplyFrom,
                        translatePosted: opts.translatePosted,
                        translateWriteReview: opts.translateWriteReview,
                        translateShow: opts.translateShow,
                        translateDetails: opts.translateDetails,
                        translateRateThisProduct: opts.translateRateThisProduct,
                        translateSelectProduct: opts.translateSelectProduct,
                        translateWriteReviewPlaceholder: opts.translateWriteReviewPlaceholder,
                        translateSubmitReview: opts.translateSubmitReview,
                        translateYourNamePlaceholder: opts.translateYourNamePlaceholder,
                        translateEmailAddressPlaceholder: opts.translateEmailAddressPlaceholder,
                        translateThankyouForYourReview: opts.translateThankyouForYourReview,
                        translateYourReviewHasBeenSubmitted: opts.translateYourReviewHasBeenSubmitted,
                        translateReviewsCount: opts.translateReviewsCount,
                        translateVerifiedBuyer: opts.translateVerifiedBuyer,
                        translateUnverifiedBuyer: opts.translateUnverifiedBuyer,
                        translateVerifiedBuyerYes: opts.translateVerifiedBuyerYes,
                        translateVerifiedBuyerNo: opts.translateVerifiedBuyerNo,
                        translateAnonymousReviewerName: opts.translateAnonymousReviewerName
                    };
                    if (opts.useMpn) {
                        options.mpn = sku;
                    }
                    if (opts.useCustomLookup) {
                        options.lookup = sku;
                    }
                    if (opts.writeButton != undefined) {
                        options.writeButton = opts.writeButton;
                    }
                    productWidget("reviews_widget", options);
                }
            }
        }
    }

};
if (typeof ratingSnippetCallback == 'function') {
    ratingSnippetCallback();
}